export default __webpack_public_path__ + "static/media/collectionscarousel.7f205c7a.svg";